"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Coordinate = _interopRequireDefault(require("../geom/Coordinate"));

var _DD = _interopRequireDefault(require("../math/DD"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CGAlgorithmsDD =
/*#__PURE__*/
function () {
  function CGAlgorithmsDD() {
    _classCallCheck(this, CGAlgorithmsDD);

    CGAlgorithmsDD.constructor_.apply(this, arguments);
  }

  _createClass(CGAlgorithmsDD, [{
    key: "getClass",
    value: function getClass() {
      return CGAlgorithmsDD;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "orientationIndex",
    value: function orientationIndex(p1, p2, q) {
      var index = CGAlgorithmsDD.orientationIndexFilter(p1, p2, q);
      if (index <= 1) return index;

      var dx1 = _DD.default.valueOf(p2.x).selfAdd(-p1.x);

      var dy1 = _DD.default.valueOf(p2.y).selfAdd(-p1.y);

      var dx2 = _DD.default.valueOf(q.x).selfAdd(-p2.x);

      var dy2 = _DD.default.valueOf(q.y).selfAdd(-p2.y);

      return dx1.selfMultiply(dy2).selfSubtract(dy1.selfMultiply(dx2)).signum();
    }
  }, {
    key: "signOfDet2x2",
    value: function signOfDet2x2() {
      if (arguments[3] instanceof _DD.default && arguments[2] instanceof _DD.default && arguments[0] instanceof _DD.default && arguments[1] instanceof _DD.default) {
        var _x = arguments[0],
            _y = arguments[1],
            _x2 = arguments[2],
            _y2 = arguments[3];

        var det = _x.multiply(_y2).selfSubtract(_y.multiply(_x2));

        return det.signum();
      } else if (typeof arguments[3] === "number" && typeof arguments[2] === "number" && typeof arguments[0] === "number" && typeof arguments[1] === "number") {
        var dx1 = arguments[0],
            dy1 = arguments[1],
            dx2 = arguments[2],
            dy2 = arguments[3];

        var x1 = _DD.default.valueOf(dx1);

        var y1 = _DD.default.valueOf(dy1);

        var x2 = _DD.default.valueOf(dx2);

        var y2 = _DD.default.valueOf(dy2);

        var det = x1.multiply(y2).selfSubtract(y1.multiply(x2));
        return det.signum();
      }
    }
  }, {
    key: "intersection",
    value: function intersection(p1, p2, q1, q2) {
      var denom1 = _DD.default.valueOf(q2.y).selfSubtract(q1.y).selfMultiply(_DD.default.valueOf(p2.x).selfSubtract(p1.x));

      var denom2 = _DD.default.valueOf(q2.x).selfSubtract(q1.x).selfMultiply(_DD.default.valueOf(p2.y).selfSubtract(p1.y));

      var denom = denom1.subtract(denom2);

      var numx1 = _DD.default.valueOf(q2.x).selfSubtract(q1.x).selfMultiply(_DD.default.valueOf(p1.y).selfSubtract(q1.y));

      var numx2 = _DD.default.valueOf(q2.y).selfSubtract(q1.y).selfMultiply(_DD.default.valueOf(p1.x).selfSubtract(q1.x));

      var numx = numx1.subtract(numx2);
      var fracP = numx.selfDivide(denom).doubleValue();

      var x = _DD.default.valueOf(p1.x).selfAdd(_DD.default.valueOf(p2.x).selfSubtract(p1.x).selfMultiply(fracP)).doubleValue();

      var numy1 = _DD.default.valueOf(p2.x).selfSubtract(p1.x).selfMultiply(_DD.default.valueOf(p1.y).selfSubtract(q1.y));

      var numy2 = _DD.default.valueOf(p2.y).selfSubtract(p1.y).selfMultiply(_DD.default.valueOf(p1.x).selfSubtract(q1.x));

      var numy = numy1.subtract(numy2);
      var fracQ = numy.selfDivide(denom).doubleValue();

      var y = _DD.default.valueOf(q1.y).selfAdd(_DD.default.valueOf(q2.y).selfSubtract(q1.y).selfMultiply(fracQ)).doubleValue();

      return new _Coordinate.default(x, y);
    }
  }, {
    key: "orientationIndexFilter",
    value: function orientationIndexFilter(pa, pb, pc) {
      var detsum = null;
      var detleft = (pa.x - pc.x) * (pb.y - pc.y);
      var detright = (pa.y - pc.y) * (pb.x - pc.x);
      var det = detleft - detright;

      if (detleft > 0.0) {
        if (detright <= 0.0) {
          return CGAlgorithmsDD.signum(det);
        } else {
          detsum = detleft + detright;
        }
      } else if (detleft < 0.0) {
        if (detright >= 0.0) {
          return CGAlgorithmsDD.signum(det);
        } else {
          detsum = -detleft - detright;
        }
      } else {
        return CGAlgorithmsDD.signum(det);
      }

      var errbound = CGAlgorithmsDD.DP_SAFE_EPSILON * detsum;

      if (det >= errbound || -det >= errbound) {
        return CGAlgorithmsDD.signum(det);
      }

      return 2;
    }
  }, {
    key: "signum",
    value: function signum(x) {
      if (x > 0) return 1;
      if (x < 0) return -1;
      return 0;
    }
  }]);

  return CGAlgorithmsDD;
}();

exports.default = CGAlgorithmsDD;

CGAlgorithmsDD.constructor_ = function () {};

CGAlgorithmsDD.DP_SAFE_EPSILON = 1e-15;